import cx from 'classnames';
import { themeStyles, ToggleTheme } from './ToggleSwitch.theme';
import { ToggleSwitchProps } from './ToggleSwitch.types';

const ToggleSwitch = ({
  id,
  label = '',
  theme = ToggleTheme.LIGHT,
  isChecked = false,
  isDisabled = false,
  dataTestId = 'toggle-switch',
  ddActionName,
  dataPendoId,
  onChange = () => undefined,
}: ToggleSwitchProps): React.ReactElement => {
  const currentTheme = themeStyles[theme] || themeStyles[ToggleTheme.LIGHT];
  return (
    <label className="inline-flex items-center" data-dd-action-name={ddActionName ?? label} data-pendo-id={dataPendoId}>
      <input
        id={id}
        name={id}
        aria-label={id}
        data-test-id={dataTestId}
        type="checkbox"
        className="hidden"
        checked={isChecked}
        onChange={(event) => !isDisabled && onChange(event.target.checked)}
        disabled={isDisabled}
      />
      <span
        className={cx(
          'relative inline-block align-middle rounded-full transition-colors duration-150 ease-in-out',
          currentTheme.iconSize ?? 'w-7 h-4',
          {
            [currentTheme.iconChecked]: isChecked,
            [currentTheme.iconUnchecked]: !isChecked,
            'cursor-pointer': !isDisabled,
            'opacity-70 cursor-not-allowed': isDisabled,
          },
        )}
      >
        <span
          className={cx(
            'absolute h-3 w-3 rounded-full top-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all duration-150 ease-in-out',
            currentTheme.dot,
            {
              [currentTheme.dotChecked ?? '']: isChecked,
              [currentTheme.dotUnchecked ?? '']: !isChecked,
              [currentTheme.dotCheckedPosition ?? 'left-[calc(100%-0.5rem)]']: isChecked,
              [currentTheme.dotUncheckedPosition ?? 'left-2']: !isChecked,
            },
          )}
        />
      </span>
      {label && <span className="pl-1 select-none text-base">{label}</span>}
    </label>
  );
};

export default ToggleSwitch;
